import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KycMarutiRoutingModule } from './kyc-maruti-routing.module';
import { KycMarutiComponent } from './kyc-maruti.component';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [KycMarutiComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KycMarutiRoutingModule,
    BackButtonDisableModule.forRoot({preserveScrollPosition: true}),
  ]
})
export class KycMarutiModule { }
